<template>
  <div>
    <eqt-table 
      :icon="icon"
      :color="color"
      :header-color="headerColor"
      :hide-search="hideSearch"
      :hide-show-btn="hideShowBtn"
      :hide-edit-btn="hideEditBtn"
      @refresh="refresh"
      @delete="deleteItem"
      :total="total"
      :loading="loading"
      :title="computedTitle"
      :hide-actions="hideActions"
      :subtitle="computedSubtitle"
      :items="items"
      :headers="computedHeaders">
      <template slot="add">
        <slot name="add"></slot>
      </template>
      <template slot="items" slot-scope="{ item }">
        <td>{{ item.id }}</td>
        <td>{{ item.groupation.name }}</td>
        <td>{{ item.warehouse.name }}</td>
        <td>{{ hoursConverter(item.expiration) }}</td>
        <td>{{ item.email_notification == 0 ? 'Ne' : 'Da' }}</td>
        <td class="text-xs-center">
          <v-badge slot="activator" color="blue" left :value="true" overlap>
            <template slot="badge">
              <span>{{item.users ? item.users.length : 0}}</span>
            </template>
            <v-tooltip top v-if="hasRole(UserRoles.ADMIN)">
              <v-btn slot="activator" class="mx-0" small flat icon color="indigo"  @click.stop="openAttachUserModal(item)">
                <v-icon  small>person_add</v-icon>
              </v-btn>
              <span>{{$t('Pages.WorkplaceProductRules.add_new_exception')}}</span>
            </v-tooltip>
          </v-badge>
          <v-tooltip top v-if="hasRole(UserRoles.ADMIN) && item.users && item.users.length > 0">
            <v-btn slot="activator" class="mx-0" small flat icon color="indigo"  @click.stop="openDetachUserModal(item)">
              <v-icon  small>mdi-account-minus</v-icon>
            </v-btn>
            <span>{{$t('Pages.WorkplaceProductRules.remove_exception')}}</span>
          </v-tooltip>
        </td>
      </template>
      <template slot="action-items" slot-scope="{ item }">
        <v-tooltip top v-if="hasRole(UserRoles.ADMIN)">
          <v-btn slot="activator" class="mx-0" small flat icon color="warning"  @click="openAddGroupationRuleModal(item, true)">
            <v-icon  small>edit</v-icon>
          </v-btn>
          <span>{{$t('Core.Fields.edit')}}</span>
        </v-tooltip>
        <slot name="action-items" :item="item"></slot>
      </template>
    </eqt-table>
    <add-groupation-rule-modal @refreshGroupationRule="refresh" v-model="showAddGroupationRuleModal" @close="showAddGroupationRuleModal = false" :workplaceGroupationRule="selectedItem" :pagination="pagination" :edit="edit" :groupations="groupations" :warehouses="warehouses"></add-groupation-rule-modal>
    <attach-user-modal @refresh="refresh" v-model="showAttachUserModal" :workplaceGroupationRuleId="workplaceGroupationRuleId" @close="showAttachUserModal = false" :users="users"></attach-user-modal>
    <detach-user-modal @refresh="refresh" v-model="showDetachUserModal" :workplaceGroupationRuleId="workplaceGroupationRuleId" :users="groupationUsers" @close="showDetachUserModal = false"></detach-user-modal>
  </div>
</template>

<script>
  import i18n from '@/i18n'
  import EqtTable from '../../components/core/Table'
  import AddGroupationRuleModal from '../workplaceGroupationRules/Add'
  import AttachUserModal from './AttachUserModal'
  import DetachUserModal from './DetachUserModal'
  export default {
    name: "groupation-rules-table",
    components: {EqtTable, AddGroupationRuleModal, AttachUserModal, DetachUserModal},
    props: {
      items: {
        type: Array,
        required: true
      },
      total: {
        type: Number,
        default: 0,
      },
      loading: {
        type: Boolean,
        default: false
      },
      hideActions: {
        type: Boolean,
        default: false
      },
      icon: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        default: 'tertiary'
      },
      headerColor: {
        type: String,
        default: 'text-primary text--darken-3'
      },
      title: {
        type: String,
        default: null,
      },
      subtitle: {
        type: String,
        default: null,
      },
      hideSubtitle: {
        type: Boolean,
        default: false
      },
      hideSearch: {
        type: Boolean,
        default: false
      },
      hideShowBtn: {
        type: Boolean,
        default: false
      },
      hideEditBtn: {
        type: Boolean,
        default: false
      },
      sortable: {
        type: Boolean,
        default: true
      },
      appendHeaders: {
        type: Array,
        default: () => []
      },
      pagination: {
        type: Object,
        default: () => {}
      },
      users: {
        type: Array,
        default: []
      },
      groupations: {
        type: Array,
        default: []
      },
      warehouses: {
        type: Array,
        default: []
      }
    },
    data: () => ({
      showAttachUserModal: false,
      showDetachUserModal: false,
      workplaceGroupationRuleId: null,
      groupationUsers: null,
      showAddGroupationRuleModal: false,
      edit: false,
      selectedItem: null,
      headers: [
        {
          sortable: true,
          text: '#',
          value: 'id'
        },
        {
          sortable: true,
          text: i18n.t('Pages.Groupations.title_singular'),
          value: 'groupation.name'
        },
        {
          sortable: true,
          text: i18n.t('Pages.Warehouses.title_singular'),
          value: 'warehouse.id'
        },
        {
          sortable: false,
          text: i18n.t('Pages.WorkplaceGroupationRules.model.expiration'),
          value: 'expiration'
        },
        {
          sortable: false,
          text: i18n.t('Pages.WorkplaceGroupationRules.model.email'),
          value: 'email'
        },
        {
          sortable: false,
          text: i18n.t('Pages.WorkplaceGroupationRules.model.exception'),
          value: 'users.profile.name',
          align: 'center'
        },
      ],
    }),
    computed:{
      computedHeaders(){
        return this.headers.concat(this.appendHeaders);
      },
      computedTitle(){
        return this.title ? this.title : this.$t('Pages.WorkplaceGroupationRules.title_singular');
      },
      computedSubtitle(){
        if(this.hideSubtitle){
          return null;
        }
        return this.subtitle ? this.subtitle : this.$t('Common.table_subtitle');
      }
    },
    methods: {
      openAttachUserModal(item){
        this.showAttachUserModal = true;
        this.workplaceGroupationRuleId = item.id
			},
      openDetachUserModal(item){
        this.showDetachUserModal = true;
        this.workplaceGroupationRuleId = item.id;
        this.groupationUsers = item.users;
      },
      refresh(data){
        this.$emit('refresh', data);
      },
      deleteItem(item){
        this.$emit('delete', item);
      },
      openAddGroupationRuleModal(item, edit) {
        this.showAddGroupationRuleModal = true;
        this.selectedItem = item;
        this.edit = edit;
      },
    }
  }
</script>

<style scoped>

</style>